/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description AllocatePayment Button
 */
import { Button as AntButton, ButtonProps } from 'antd';

import { Link } from 'react-router-dom';
import { getPaymentAllocationPath } from 'utils/router';

/**
 * AllocatePayment
 */

const AllocatePayment: React.FC<Record<'id', string> & ButtonProps & { allocationStatus?: string; showDeallocation?: boolean }> = ({
	id,
	allocationStatus = 'queued',
	...restProps
}) => {
	const shouldAllowAllocation = !allocationStatus || allocationStatus === 'queued' || allocationStatus === 'partial';

	return (
		<Link {...restProps} to={getPaymentAllocationPath(id)}>
			<AntButton size='small' color={shouldAllowAllocation ? 'primary' : 'default'} variant='outlined' {...restProps}>
				{shouldAllowAllocation ? 'Allocate' : 'View'}
			</AntButton>
		</Link>
	);
};

export default AllocatePayment;
